import React, { useEffect, useState } from "react";
import useLogout from "../../../utils/Utils";
import { useForm } from "react-hook-form";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  PreviewAltCard,
  Row,
} from "../../../components/Component";
import { Badge, Form, Label } from "reactstrap";
import { createStreamAPI, getStreamAPI, updateStreamAPI } from "../../../api/LMS/master";
import { toast } from "react-toastify";
import Head from "../../../layout/head/Head";
import Content from "../../../layout/content/Content";
import MyButton from "../../../myComponents/form/MyButton";
import Status from "../../../myComponents/form/Status";
import Required from "../../../myComponents/validate/Required";
import MyDataTable from "../../../myComponents/DataTable/MyDataTable";
import { useLocation, useNavigate } from "react-router";
import { decrypt } from "../../../utils/Encrypt";
import { hasPermission } from "../../../utils/myFunctions";

const Stream = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [mode, setMode] = useState("Add");
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const enc = JSON.parse(localStorage.getItem("userDetail"));
  const user = decrypt(enc?.data || []);
  const isView = hasPermission(user, location?.pathname, "isView");
  const isUpdate = hasPermission(user, location?.pathname, "isUpdate");
  const isDelete = hasPermission(user, location?.pathname, "isDelete");
  const isCreate = hasPermission(user, location?.pathname, "isCreate");
  const [timer, setTimer] = useState(5); // 5 seconds countdown
  useEffect(() => {
    if (!isView) {
      const interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
      // redirect to home page when the timer reaches 0
      if (timer === 0) {
        navigate(-1);
      }
      // clean up the interval when the component unmounts
      return () => clearInterval(interval);
    } else {
      setIsLoading(false);
    }
  }, [timer]);
  const logout = useLogout();
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    setError,
    clearErrors,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      status: null,
    },
  });
  const [data, setData] = useState([]);
  const [column, setColumn] = useState([
    {
      name: "Class",
      selector: (row) => row?.class,
      sortable: true,
    },
    {
      name: "Stream",
      selector: (row) => row?.name_en,
      sortable: true,
    },
    {
      name: "Stream in Hindi",
      selector: (row) => row?.name,
      sortable: true,
    },

    {
      name: "Status",
      selector: (row) => row?.status,
      cell: (row) => (
        <div style={{ cursor: "pointer" }} onClick={() => handleToggleStatus(row)}>
          <Badge color={`${row.status == "active" ? "success" : "danger"}`}>
            {row.status == "active" ? "Active" : "Inactive"}
          </Badge>
        </div>
      ),
      sortable: true,
      wrap: true,
    },
    {
      name: "Action",
      wrap: true,
      cell: (row) => (
        <div>
          {isUpdate && (
            <Button outline color={`warning`} size={`xs`} className={`me-1`} onClick={() => handleEdit(row)}>
              {" "}
              <Icon name="edit" />
            </Button>
          )}
        </div>
      ),
    },
  ]);
  const handleToggleStatus = (row) => {
    setSelectedRow(row);
    setShowModal(true);
  };
  useEffect(() => {
    getStream();
  }, []);
  const getStream = () => {
    const data = {};
    getStreamAPI(data)
      .then((res) => {
        // decrypt data
        const status = res.data.status;
        // const status = decrypt(res.data.status);
        if (status === true) {
          // const decryptedResponse = decrypt(res.data.data.tableData);
          setData(res.data.data);
          toast.clearWaitingQueue();
        } else if (status === false) {
          toast.warning(res.data.message);
          toast.clearWaitingQueue();
          setData([]);
        } else if (status === "expired") {
          toast.error(res.data.message);
          logout();
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const handleEdit = (row) => {
    window.scrollTo(0, 0);
    setIsOpen(!isOpen);
    setMode("Edit");
    setValue("id", row.id); // Add this for consistent `formData` structure
    setValue("stream", row.name_en);
    setValue("stream_hn", row.name);
    setValue("status", {
      label: row.status == "active" ? "Active" : "Inactive",
      value: row.status == "active" ? "active" : "inactive",
    });
    setValue("class", {
      label: row.class_name,
      value: row.class_id,
    });
  };
  const onFormSubmit = (data) => {
    const body = {
      class_id: 2,
      name_en: watch("stream"),
      name: watch("stream_hn"),
      status: watch("status")?.value,
      ...(mode == "Edit" && { id: watch("id") }),
    };
    if (mode == "Add") {
      createStreamAPI(body)
        .then((res) => {
          const status = res.data.status;
          if (status === true) {
            toast.success(res.data.message);
            toast.clearWaitingQueue();
            getStream();
            setIsOpen(false);
            setIsLoading(false);
          } else if (status === false) {
            setIsLoading(false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (status === "expired") {
            console.log("response", res.data);
            setIsLoading(false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          console.log("cat", err);

          setIsLoading(false);
          toast.error(err.message);
        });
    }
    if (mode == "Edit") {
      updateStreamAPI(body)
        .then((res) => {
          // const status = decrypt(res.data.status);
          const status = res.data.status;
          if (status === true) {
            toast.success(res.data.message);
            toast.clearWaitingQueue();
            getStream();
            setIsOpen(false);
            setIsLoading(false);
          } else if (status === false) {
            setIsLoading(false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (status === "expired") {
            setIsLoading(false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          setIsLoading(false);
          toast.error(err.message);
        });
    }
  };
  return (
    <>
      <Head title="Stream | Master" />
      <Content>
        {!isView ? (
          <div className="p-5" style={{}}>
            <p style={{ color: "crimson", textAlign: "center" }}>{"Unauthorized"}</p>
            <p style={{ textAlign: "center" }}>
              You will be redirected to the home page in <b style={{ color: "crimson" }}>{timer} </b> seconds.
            </p>
          </div>
        ) : (
          <>
            <BlockHead size={`sm`}>
              <BlockBetween>
                <BlockHeadContent>
                  <BlockTitle page tag="h3">
                    {"Stream"}
                  </BlockTitle>
                </BlockHeadContent>
                {isCreate && (
                  <BlockHeadContent>
                    <div>
                      <Button
                        color={`primary`}
                        outline
                        className={`me-n1`}
                        onClick={() => {
                          setIsOpen(!isOpen);
                          setMode("Add");
                          reset();
                        }}
                      >
                        <Icon name={isOpen ? "minus" : "plus"} />
                      </Button>
                    </div>
                  </BlockHeadContent>
                )}
              </BlockBetween>
            </BlockHead>
            <Block>
              <Row className={`g-gs`}>
                {isOpen && (
                  <PreviewAltCard>
                    <Form onSubmit={handleSubmit(onFormSubmit)}>
                      <Row className={`g-gs`}>
                        {/*Subject Name */}
                        <Col md="4" sm="3" xxl="5">
                          <div className="form-group">
                            <Label className="form-label" htmlFor="stream">
                              {"Stream Name"}
                              <Required />
                            </Label>
                            <div className="form-control-wrap">
                              <input
                                placeholder={"Enter stream name"}
                                type="text"
                                id="stream"
                                {...register("stream", {
                                  required: {
                                    value: true,
                                    message: "Stream name is required",
                                  },
                                  // pattern: {
                                  //   value: /^(?!\s*$)[a-zA-Z /.]*$/,
                                  //   message: "Only alphabets are allowed",
                                  // },
                                  minLength: {
                                    value: 3,
                                    message: "Stream name must be at least 2 characters long",
                                  },
                                  maxLength: {
                                    value: 50,
                                    message: "Stream name cannot exceed 50 characters",
                                  },
                                })}
                                className="form-control"
                                value={watch("stream")}
                                onChange={(e) => {
                                  // let value = e.target.value.replace(/[^A-Za-z\s]/g, ""); // Remove invalid characters
                                  // value = value.replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                                  setValue("stream", e.target.value);
                                  trigger("stream"); // Trigger validation
                                }}
                                // onInput={(e) => {
                                //   e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, "");
                                // }}
                              />
                              {errors.stream && <span className="invalid">{errors?.stream?.message}</span>}
                            </div>
                          </div>
                        </Col>{" "}
                        {/*Stream Name Hindi */}
                        <Col md="4" sm="3" xxl="5">
                          <div className="form-group">
                            <Label className="form-label" htmlFor="stream_hn">
                              {"Stream Name in Hindi"}
                              <Required />
                            </Label>
                            <div className="form-control-wrap">
                              <input
                                placeholder={"Enter stream name in hindi"}
                                type="text"
                                id="stream_hn"
                                {...register("stream_hn", {
                                  required: {
                                    value: true,
                                    message: "Stream name in hindi is required",
                                  },
                                  // pattern: {
                                  //   value: /^(?!\s*$)[a-zA-Z /.]*$/,
                                  //   message: "Only alphabets are allowed",
                                  // },
                                  minLength: {
                                    value: 3,
                                    message: "Stream name in hindi must be at least 2 characters long",
                                  },
                                  maxLength: {
                                    value: 50,
                                    message: "Stream name in hindi cannot exceed 50 characters",
                                  },
                                })}
                                className="form-control"
                                value={watch("stream_hn")}
                                onChange={(e) => {
                                  // let value = e.target.value.replace(/[^A-Za-z\s]/g, ""); // Remove invalid characters
                                  // value = value.replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                                  setValue("stream_hn", e.target.value);
                                  trigger("stream_hn"); // Trigger validation
                                }}
                                // onInput={(e) => {
                                //   e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, "");
                                // }}
                              />
                              {errors.stream_hn && <span className="invalid">{errors?.stream_hn?.message}</span>}
                            </div>
                          </div>
                        </Col>{" "}
                        {/* Status */}
                        <Col md="2" sm="3" xxl="2">
                          <Status
                            setValue={setValue}
                            trigger={trigger}
                            register={register}
                            watch={watch}
                            errors={errors}
                          />
                        </Col>
                      </Row>
                      <Col md="2" className={``}>
                        <MyButton isLoading={isLoading} mode={mode} />
                      </Col>
                    </Form>
                  </PreviewAltCard>
                )}
                <MyDataTable data={data} columns={column} title={"Stream"} isLoading={isLoading} />
              </Row>
            </Block>
          </>
        )}
      </Content>
    </>
  );
};

export default Stream;
